// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"814":"7210d4a4","973":"58b3911e","988":"c25881c6"}[chunkId] + ".chunk.js";
};